<template>
    <div class="friends-component">
        <div class="clearfix">
            <Loading :data="pendings" :hideOnEmpty="true">
                <template #title><h2>{{ $t('solicitudesDeAmistad') }}</h2></template>
                <div id="friends-list">
                    <FriendCard
                        v-for="user in pendings"
                        v-bind:key="user.id"
                        :user="user"
                    >
                        <template slot>
                            <span>{{ $t('deseaSerTuAmigo') }}</span>
                            <div class="pending-buttons">
                                <button
                                    @click="onAcceptClick(user)"
                                    class="btn btn-accept-request"
                                >
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                </button>
                                <button
                                    @click="onRejectClick(user)"
                                    class="btn btn-primary"
                                >
                                    <i
                                        class="fa fa-times"
                                        aria-hidden="true"
                                    ></i>
                                </button>
                                <span v-if="idRequesting == user.id"
                                    >{{ $t('enProceso') }}</span
                                >
                            </div>
                        </template>
                    </FriendCard>
                </div>
                <template #no-data><p class="alert alert-warning" role="alert">
                    {{ $t('noHaySolicitudesNuevas') }}
                </p></template>
                <template #loading><p class="alert alert-info" role="alert">
                    <img
                        src="https://carpoolear.com.ar/static/img/loader.gif"
                        alt=""
                        class="ajax-loader"
                    />
                    {{ $t('cargandoSolicitudes') }}
                </p></template>
            </Loading>
        </div>

        <h2>{{ $t('amigos') }}</h2>
        <router-link
            :to="{ name: 'friends_search' }"
            tag="button"
            class="btn btn-primary search-more"
        >
            {{ $t('buscarNuevosAmigos') }}
        </router-link>
        <h2>{{ $t('misAmigos') }}</h2>
        <div class="friend-form form-inline form-inline-with-margin">
            <div class="form-group">
                <label for="input-name">{{ $t('filtrarPorNombre') }}</label>
                <input
                    v-on:input="onTextChange"
                    v-model="text"
                    type="text"
                    class="form-control filter-input"
                    id="input-name"
                    :placeholder="$t('ingresarNombre')"
                />
            </div>
        </div>
        <Loading :data="friends">
            <div id="friends-list">
                <FriendRequestCard
                    v-for="user in friends"
                    v-bind:key="user.id"
                    :user="user"
                >
                    <template slot>
                        <div>
                            <div
                                @click="onDeleteClick(user)"
                                class="delete-friend"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </div>
                            <span v-if="idRequesting == user.id"
                                >{{ $t('enProceso') }}</span
                            >
                        </div>
                    </template>
                </FriendRequestCard>
            </div>
            <template #no-data><p class="alert alert-warning" role="alert">
                {{ noResult }}
            </p></template>
            <template #loading><p class="alert alert-info" role="alert">
                <img
                    src="https://carpoolear.com.ar/static/img/loader.gif"
                    alt=""
                    class="ajax-loader"
                />
                {{ $t('cargandoAmigos') }}
            </p></template>
        </Loading>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '../Loading.vue';
import FriendCard from './FriendCard';
import FriendRequestCard from './FriendRequestCard';

export default {
    name: 'friends_setting',
    data() {
        return {
            text: '',
            idRequesting: 0
        };
    },
    computed: {
        ...mapGetters({
            friends: 'friends/friends',
            pendings: 'friends/pendings'
        }),

        noResult() {
            if (this.text.length) {
                return this.$t('noHayResultados');
            } else {
                return this.$t('noTienesNingunAmigoAun');
            }
        }
    },
    methods: {
        ...mapActions({
            search: 'friends/friendsSearch',
            lookPeginds: 'friends/pending',
            accept: 'friends/accept',
            reject: 'friends/reject',
            delete: 'friends/delete'
        }),

        onTextChange() {
            this.search({ value: this.text });
        },

        onAcceptClick(user) {
            this.idRequesting = user.id;
            this.accept(user.id).then(
                () => {
                    this.idRequesting = 0;
                },
                () => {
                    this.idRequesting = 0;
                }
            );
        },

        onRejectClick(user) {
            this.idRequesting = user.id;
            this.reject(user.id).then(
                () => {
                    this.idRequesting = 0;
                },
                () => {
                    this.idRequesting = 0;
                }
            );
        },

        onDeleteClick(user) {
            this.idRequesting = user.id;
            this.delete(user.id).then(
                () => {
                    this.idRequesting = 0;
                },
                () => {
                    this.idRequesting = 0;
                }
            );
        }
    },

    mounted() {
        this.search({});
        this.lookPeginds();
    },
    components: {
        Loading,
        FriendCard,
        FriendRequestCard
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-primary {
    padding: 0.8em;
}
h2 {
    margin-top: 0;
    margin-bottom: 0;
}
.form-group {
    margin-bottom: 15px;
}
.form-group {
    margin-bottom: 0;
}
.request-list div.rate-pending_component,
.friend-card {
    /* margin: 1.1em auto; */
    margin: 0;
}
label {
    margin-right: 1em;
    font-weight: 500;
    color: #333;
    font-size: 15px;
}
h2 {
    margin-bottom: 0.4em;
}
.search-more {
    margin-bottom: 1em;
}
.friend-form {
    margin-bottom: 0;
}
.alert {
    margin-top: 1em;
}

/* Stylisation moderne du champ de filtre */
.filter-input {
    height: 48px;
    padding: 12px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    font-size: 15px;
    font-family: 'Heebo', sans-serif;
    transition: all 0.3s ease;
    min-width: 300px;
    background-color: #fff;
}

.filter-input:focus {
    outline: none;
    border-color: #59c362;
    box-shadow: 0 0 0 3px rgba(89, 195, 98, 0.1);
}

.filter-input::placeholder {
    color: #999;
    font-size: 14px;
}
@media only screen and (max-width: 768px) {
    .friends-component {
        padding: 1em;
    }
    .friend-card {
        margin: 0;
    }
}
@media only screen and (min-width: 767px) {
    .friend-form {
        margin-top: 1.6em;
    }
}
</style>
